export default ({
  itemId,
  itemComment = null,
  repairCost = 0,
  return_qty = 1,
  issue,
  repairImageUrl = '',
}) => ({
  item_id: itemId,
  user_comment: itemComment,
  total_price: repairCost,
  repairImageUrl,
  selected: true,
  return_qty,
  return_desc: `Repair Reason: ${issue.display_name}`,
  repairDescription: issue.display_name,
  repair_reason_fee: repairCost,
});
